import React, { FC, ReactNode } from 'react';

import { Tooltip } from 'src/shared/components/Tooltip';
import './SingleStackedBarChart.styles.scss';

interface Props {
  data: { color: string; value: number; tooltip?: ReactNode }[];
  scaleOnHover?: boolean;
  size?: 'small' | 'large';
  width?: string | number;
  total?: number;
  className?: string;
}

export const SingleStackedBarChart: FC<Props> = ({
  data,
  scaleOnHover,
  size = 'large',
  width = '100%',
  className = '',
}) => {
  const height = size === 'small' ? '8px' : '12px';
  const total = data.reduce((count, { value }) => count + value, 0);
  const scaleClassName = scaleOnHover ? 'hover' : '';

  return (
    <div className={`stacked-bar-chart ${className}`} style={{ height, width }}>
      <div className="stacked-progress-chart">
        {data.map(({ color, value, tooltip }, index) => {
          const percentage = (value / total) * 100;

          return (
            <Tooltip key={`progress-${index}-${value}`} placement="top-end" title={tooltip ? tooltip : ''}>
              <div
                className={`stacked-progress-item-chart ${scaleClassName}`}
                style={{ backgroundColor: color, width: `${percentage}%` }}
              />
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
};
